/** Matches backend PeriodType. Used for stats date filter (Asia/Bishkek). */
export const PeriodType = {
  TODAY: 1,
  YESTERDAY: 2,
  WEEK: 3,
  MONTH: 4,
  ALL_TIME: 5,
  PREVIOUS_WEEK: 6,
  PREVIOUS_MONTH: 7,
  THIS_YEAR: 8,
  PREVIOUS_YEAR: 9,
};

const ORDER = [
  PeriodType.TODAY,
  PeriodType.YESTERDAY,
  PeriodType.WEEK,
  PeriodType.PREVIOUS_WEEK,
  PeriodType.MONTH,
  PeriodType.PREVIOUS_MONTH,
  PeriodType.THIS_YEAR,
  PeriodType.PREVIOUS_YEAR,
  PeriodType.ALL_TIME,
];

/** Next period in cycle (TODAY → … → PREVIOUS_YEAR → ALL_TIME → TODAY). */
export function getNextPeriodId(currentId) {
  const idx = ORDER.indexOf(currentId);
  if (idx === -1) return PeriodType.TODAY;
  const nextIdx = (idx + 1) % ORDER.length;
  return ORDER[nextIdx];
}

/** Button label for period (short, for UI). */
export const PeriodLabel = {
  [PeriodType.TODAY]: '🕑 Сегодня',
  [PeriodType.YESTERDAY]: '🕑 Вчера',
  [PeriodType.WEEK]: 'Текущая нед.',
  [PeriodType.MONTH]: 'Текущий мес.',
  [PeriodType.ALL_TIME]: '🕑 Всё время',
  [PeriodType.PREVIOUS_WEEK]: 'Прошлая нед.',
  [PeriodType.PREVIOUS_MONTH]: 'Прошлый мес.',
  [PeriodType.THIS_YEAR]: 'Этот год',
  [PeriodType.PREVIOUS_YEAR]: 'Прошлый год',
};

export default PeriodType;
